// The `command="show-modal"` buttons of `ui/_dialog` (phase 072).
//
// An invoker opens its `<dialog>` in the browser itself, with no script of
// ours — and so with no wait for `el-dialog` to finish a closing
// (`lib/dialog_idle.ts`): a person who closes a dialog by Escape and taps its
// button again at once reopened a dialog the library's trailing `close()`
// then shut (`spec/system/redesign/primitives_spec.rb`). The command the
// invoker sends is caught on its way down to the dialog, and a dialog inside
// an `el-dialog` is shown by the library once it is idle — two frames later
// when nothing is closing. The invoker's click is never cancelled: the
// browser still delivers the command, and only its default, the immediate
// `showModal()`, is replaced. A dialog outside `el-dialog`, an open one and
// every other command go on as the browser sends them.
import { whenDialogIdle } from "./dialog_idle"

type ElDialog = HTMLElement & { show?: () => void }
type CommandEventLike = Event & { command?: string }

export function deferDialogInvokers(root: Pick<Document, "addEventListener"> = document): void {
  root.addEventListener("command", (event) => {
    if ((event as CommandEventLike).command !== "show-modal") return

    const dialog = event.target as HTMLDialogElement | null
    if (dialog === null || dialog.localName !== "dialog" || dialog.open) return

    const host = dialog.closest<ElDialog>("el-dialog")
    if (host === null || typeof host.show !== "function") return

    event.preventDefault()
    void whenDialogIdle(host).then(() => {
      if (dialog.isConnected && !dialog.open) host.show?.()
    })
  }, { capture: true })
}

